module.exports = "<div class=\"header\">\n  <h1><a href=\".\"><</a> Tangle</h1>\n</div>\n<iframe src=\"apps/tangle/index.html\"></iframe>\n"


//////////////////
// WEBPACK FOOTER
// /home/manu/ArtCode/artCode/artCode/src/app/pages/tangle/tangle.component.html
// module id = ../../../../../src/app/pages/tangle/tangle.component.html
// module chunks = main